export default __webpack_public_path__ + "img/d8c938e9e47ea1bcade924f1bbda42a3.png";